// extracted by mini-css-extract-plugin
export default {"text":"AiPhotoGenerationLoaderText__text--B4oTV","textHiding":"AiPhotoGenerationLoaderText__textHiding--2q5de"};